import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

interface Bank {
    firstName: any,
    lastName: any,
    dob: any,
    genderId: any,
    phone: any,
    email: any,
    profileImageUrl: any,
    auditTrailId: any,
    isActive: boolean
}

interface BanksState {
    data: Bank[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const URL = import.meta.env.VITE_API_COOK_URL;


export const fetchBanks = createAsyncThunk<Bank[], void, { rejectValue: string }>(
    'Banks/fetchBanks',
    async (_, { rejectWithValue }) => {
        try {
            const response = await apiService.get<{ data: Bank[] }>('/get_all_settlement_bank_account', PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const createBank = createAsyncThunk<Bank, any, { rejectValue: string }>(
    'Banks/createBank',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.post<{ data: Bank }>('create_settlement_bank_account', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);

export const updateBank = createAsyncThunk<Bank, any, { rejectValue: string }>(
    'Banks/updateBank',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.put<{ data: Bank }>('update_settlement_bank_account', params, PORT, URL);
            return response.data;
        } catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
        }
    }
);
export const BankSlice = createSlice({
    name: 'Banks',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as BanksState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Diet Mapping Code
            .addCase(fetchBanks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBanks.fulfilled, (state, action: PayloadAction<Bank[]>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchBanks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(createBank.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createBank.fulfilled, (state, action: PayloadAction<Bank>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(createBank.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
            .addCase(updateBank.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateBank.fulfilled, (state, action: PayloadAction<Bank>) => {
                state.loading = false;
                state.data.push(action.payload);
            })
            .addCase(updateBank.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ?? 'Unknown error';
            })
    },
});

export default BankSlice.reducer;